module.exports = __webpack_public_path__ + "static/media/Electric_icon.c1481683.svg";